import { useCallback, useState } from "react";
import { ImpersonateLookupStore, runSearch } from "./store";
import { startNewSession } from "../store";

import TeamMember from "$components/profile-icon/team-member";

const UserLookup = () => {
    const [nameFilter, setNameFilter] = useState("");
    const options = ImpersonateLookupStore.useState((s) => s.options);

    const search = useCallback(() => {
        runSearch(nameFilter);
    }, [nameFilter]);

    return (
        <div>
            <div className="button-group">
                <div className="form-field">
                    <label>Look up by name</label>
                    <input type="text" onChange={(e) => setNameFilter(e.currentTarget.value)} value={nameFilter} />
                </div>
                <button className="button -secondary -small" onClick={search}>
                    Search
                </button>
            </div>
            <br />
            <div className="team-members -list">
                {options.map((o) => {
                    return (
                        <div>
                            <button
                                key={`user_${o.userId}`}
                                onClick={async () => {
                                    await startNewSession(o.userId);
                                    window.location.reload();
                                }}
                                className="button -text -large"
                            >
                                {o.displayName}
                            </button>
                            <br />
                            <br />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default UserLookup;
